import { swap } from './helpers'

const findEndNode = (array, position, arraySteps, colorSteps) => {
    //COME BACK WHEN READY : )
    return
}

export default findEndNode